import React from 'react';
import { AssetAddiFlashLogoSvgUrl } from '@addi/foundation/dist/web/assets';
import { AddiFlashLogo, FooterContainer, FooterText, AddiFlashText } from './addi-flash-footer.styled';
export const AddiFlashFooter = () => (React.createElement(FooterContainer, null,
    React.createElement(FooterText, null, "POWERED BY"),
    React.createElement(AddiFlashLogo, { src: AssetAddiFlashLogoSvgUrl }),
    React.createElement(AddiFlashText, null, "AddiFlash")));
//# sourceMappingURL=addi-flash-footer.js.map